/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * イベント再実行結果
 */
export interface EventReprocessInfo { 
    /**
     * イベントID：半角数字
     */
    eventId?: string;
    /**
     * イベント再実行結果コード：半角
     */
    eventReprocessResultCode?: string;
}

